// Module
var code = "<div> <h4 class=\"alignc\">{{ text }}</h4> <ul v-if=\"infos != null && infos.length > 0\" class=\"info box\"> <li v-for=\"info in infos\">{{ info }}</li> </ul> <div class=\"alignc top18\"> <button class=\"color-accent-fill min120\" @click=\"ok()\">{{ okButtonText }}</button> </div> </div> ";
// Exports
export default code;